<template>
    <div class="organization-logo" :class="modifierClasses" @click.prevent="handleClick">
        <img
            v-if="organization.logoUrl"
            :src="organization.logoUrl"
            class="organization-logo__image"
            :alt="`${organization.name} logo`"
        />
    </div>
</template>

<script>
export default {
    props: {
        user: {
            type: Object,
            default: () => {},
        },
        size: {
            type: String,
            default: 'default',
        },
    },
    computed: {
        organization() {
            return {
                name: this.user.organizationName,
                number: this.user.organizationNumber,
                logoUrl: this.user.organizationLogotypeUrl,
            };
        },
        modifierClasses() {
            return {
                'organization-logo--upload': this.size === 'upload',
            };
        },
    },
    methods: {
        handleClick() {
            this.$emit('click');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/sass/_variables.scss';

.organization-logo {
    position: relative;

    &--upload {
        width: 260px;
        height: 150px;
    }

    &__image {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
}
</style>
